exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_object-pie.js
// module id = 47
// module chunks = 0